import { ApplicationRootState } from 'redux-core/types';
import { createSelector } from 'reselect';
import { initialState } from './reducer';
import { RoleState } from './types';
import {
    INTERNAL_ADMIN_USER_ROLE_IDS,
    CLIENT_USER_ROLE_IDS,
    ADVERTISER_USER_ROLE_IDS,
} from './constants';

export const selectAdminRole = (state: ApplicationRootState): RoleState =>
    state.admin.role || initialState;

export const selectRoleList = createSelector(
    selectAdminRole,
    (state) => state.list
);

export const internalAdminUserRoleList = createSelector(
    selectAdminRole,
    (state) => {
        return (
            state.list.data?.filter((role) =>
                INTERNAL_ADMIN_USER_ROLE_IDS.includes(role.role_id)
            ) ?? []
        );
    }
);

export const clientUserRoleList = createSelector(selectAdminRole, (state) => {
    return (
        state.list.data?.filter((role) =>
            CLIENT_USER_ROLE_IDS.includes(role.role_id)
        ) ?? []
    );
});

export const advertiserUserRoleList = createSelector(
    selectAdminRole,
    (state) => {
        return (
            state.list.data?.filter((role) =>
                ADVERTISER_USER_ROLE_IDS.includes(role.role_id)
            ) ?? []
        );
    }
);
